module.exports = __webpack_public_path__ + "img/globe.c63627b2.svg";